import { useEffect, useState } from 'react';
import './App.css';
import Home from './Pages/Home';
import About from './Pages/About';
import Apply from './Pages/Apply';
import Recipients from './Pages/Recipients';
import News from './Pages/News';
import Contact from './Pages/Contact';
import HeehyunChoi from './Archives/Portfolio Item/HeehyunChoi';
import MiraeKhRhee from './Archives/Portfolio Item/MiraeKhRhee';
import YoungJoonKwak from './Archives/Portfolio Item/YoungJoonKwak';
import RobertRhee from './Archives/Portfolio Item/RobertRhee';
import JenniferMoon from './Archives/Portfolio Item/JenniferMoon';
import OlgaLah from './Archives/Portfolio Item/OlgaLah';
import JeanShin from './Archives/Portfolio Item/JeanShin';
import KakyoungLee from './Archives/Portfolio Item/KakyoungLee';
import JayeRhee from './Archives/Portfolio Item/JayeRhee';
import WonJuLim from './Archives/Portfolio Item/WonJuLim';
import JenaHKim from './Archives/Portfolio Item/JenaHKim';
import MariaPark from './Archives/Portfolio Item/MariaPark';
import JyungMeePark from './Archives/Portfolio Item/JyungMeePark';
import DoHoSuh from './Archives/Portfolio Item/DoHoSuh';
import YunHeeMin from './Archives/Portfolio Item/YunHeeMin';
import AliceParkSpurr from './Archives/Portfolio Item/AliceParkSpurr';
import ByronKim from './Archives/Portfolio Item/ByronKim.js';
import SookJinJo from './Archives/Portfolio Item/SookJinJo';
import YunDongNam from './Archives/Portfolio Item/YunDongNam';
import post3430 from './Archives/3430';
import post3257 from './Archives/3257';
import post3155 from './Archives/3155';
import { handleInternalNavigation } from './navigation';

const pages = [
  { id: 'home', label: 'Home', component: Home },
  { id: 'about', label: 'About', component: About },
  { id: 'apply', label: 'Apply', component: Apply },
  { id: 'recipients', label: 'Recipients', component: Recipients },
  { id: 'news', label: 'News', component: News },
  { id: 'contact', label: 'Contact', component: Contact },
];

const archivePages = [
  {
    path: '/archives/portfolio-item/heehyun-choi',
    label: 'Heehyun Choi',
    component: HeehyunChoi,
  },
  {
    path: '/archives/portfolio-item/mirae-kh-rhee',
    label: 'Kate-Hers Rhee',
    component: MiraeKhRhee,
  },
  {
    path: '/archives/portfolio-item/young-joon-kwak',
    label: 'Young Joon Kwak',
    component: YoungJoonKwak,
  },
  {
    path: '/archives/portfolio-item/robert-rhee',
    label: 'Robert Rhee',
    component: RobertRhee,
  },
  {
    path: '/archives/portfolio-item/jennifer-moon',
    label: 'Jennifer Moon',
    component: JenniferMoon,
  },
  {
    path: '/archives/portfolio-item/olga-lah',
    label: 'Olga Lah',
    component: OlgaLah,
  },
  {
    path: '/archives/portfolio-item/jean-shin',
    label: 'Jean Shin',
    component: JeanShin,
  },
  {
    path: '/archives/portfolio-item/kakyoung-lee',
    label: 'Kakyoung Lee',
    component: KakyoungLee,
  },
  {
    path: '/archives/portfolio-item/jaye-rhee',
    label: 'Jaye Rhee',
    component: JayeRhee,
  },
  {
    path: '/archives/portfolio-item/won-ju-lim',
    label: 'Won Ju Lim',
    component: WonJuLim,
  },
  {
    path: '/archives/portfolio-item/jena-h-kim',
    label: 'Jena H. Kim',
    component: JenaHKim,
  },
  {
    path: '/archives/portfolio-item/maria-park',
    label: 'Maria Park',
    component: MariaPark,
  },
  {
    path: '/archives/portfolio-item/jyung-mee-park',
    label: 'Jyung Mee Park',
    component: JyungMeePark,
  },
  {
    path: '/archives/portfolio-item/do-ho-suh',
    label: 'Do-Ho Suh',
    component: DoHoSuh,
  },
  {
    path: '/archives/portfolio-item/yunhee-min',
    label: 'Yunhee Min',
    component: YunHeeMin,
  },
  {
    path: '/archives/portfolio-item/alice-park-spurr',
    label: 'Alice Park-Spurr',
    component: AliceParkSpurr,
  },
  {
    path: '/archives/portfolio-item/byron-kim',
    label: 'Byron Kim',
    component: ByronKim,
  },
  {
    path: '/archives/portfolio-item/sook-jin-jo',
    label: 'Sook Jin Jo',
    component: SookJinJo,
  },
  {
    path: '/archives/portfolio-item/yun-dong-nam',
    label: 'Yun-Dong Nam',
    component: YunDongNam,
  },
  {
    path: '/archives/3430',
    label: 'Heehyun Choi Exhibit News',
    component: post3430,
  },
  {
    path: '/archives/3257',
    label: 'Luna Luna Visit',
    component: post3257,
  },
  {
    path: '/archives/3155',
    label: 'Mirae Kh Rhee Exhibit News',
    component: post3155,
  },
];

const socialLinks = [
  { label: 'Facebook', href: 'https://www.facebook.com/kafausa/', icon: FacebookIcon },
  { label: 'Instagram', href: 'https://www.instagram.com/kafa.us/', icon: InstagramIcon },
];

const footerSocialLinks = [
  ...socialLinks,
  { label: 'Email', href: 'mailto:kafaaward@gmail.com', icon: EmailIcon },
];

const footerLinks = pages.filter(({ id }) => ['about', 'apply', 'recipients', 'news', 'contact'].includes(id));

function App() {
  const [activePage, setActivePage] = useState(getPageFromRoute);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showTopButton, setShowTopButton] = useState(false);

  useEffect(() => {
    const handleRouteChange = () => {
      setActivePage(getPageFromRoute());
      setMenuOpen(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleScroll = () => {
      setShowTopButton(window.scrollY > 260);
    };

    window.addEventListener('popstate', handleRouteChange);
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const page = pages.find(({ id }) => id === activePage);
  const archivePage = archivePages.find(({ path }) => path === activePage);
  const PageComponent = archivePage?.component || page?.component || pages[0].component;
  const isArchivePage = Boolean(archivePage);

  return (
    <div className="min-h-screen bg-lavender text-slate-950">
      <Navbar
        activePage={activePage}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        isArchivePage={isArchivePage}
      />

      <main>
        <PageComponent />
      </main>

      <Footer />

      {showTopButton && (
        <button
          type="button"
          className="top-button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Back to top"
        >
          <span className="top-button-arrow" aria-hidden="true">
            &#xFE3D;
          </span>
          <span className="top-button-text">Top</span>
        </button>
      )}
    </div>
  );
}

function Navbar({ activePage, menuOpen, setMenuOpen, isArchivePage }) {
  return (
    <header className="top-0 z-50 bg-lavender/95 backdrop-blur">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
        <a href="/" onClick={handleInternalNavigation} className="group flex items-center gap-3 text-royal-purple" aria-label="KAFA home">
          <Logo />
        </a>

        <button
          className="menu-toggle inline-flex h-11 items-center justify-center border border-purple-200 bg-white/75 text-royal-purple shadow-sm md:hidden"
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((isOpen) => !isOpen)}
        >
          <span className="menu-toggle-text uppercase">Menu</span>
          <span className="hamburger" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>

        <div className={`hidden items-center gap-8 md:flex ${isArchivePage ? 'archive-nav-shell' : ''}`}>
          <PageLinks activePage={activePage} />
        </div>

        <SocialButtons links={socialLinks} />
      </nav>

      {menuOpen && (
        <div className="bg-lavender px-5 pb-5 md:hidden">
          <div className="flex flex-col gap-4 pt-4">
            <PageLinks activePage={activePage} stacked />
          </div>
        </div>
      )}
    </header>
  );
}

function Logo() {
  return (
    <span className="logo-mark">
      <span>KA</span>
      <span style={{ letterSpacing: '0.07em' }}>FA</span>
    </span>
  );
}

function PageLinks({ activePage, stacked = false }) {
  return (
    <div className={stacked ? 'flex flex-col gap-3' : 'flex items-center gap-5 text-sm font-semibold'}>
      {pages
        .filter(({ id }) => id !== 'home')
        .map(({ id, label }) => (
          <a key={id} href={`/${id}`} onClick={handleInternalNavigation} className={`nav-link ${activePage === id ? 'nav-link-active' : ''}`}>
            {label}
          </a>
        ))}
    </div>
  );
}

function Footer() {
  return (
    <footer className="bg-white/55">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-8 md:flex-row md:items-start md:justify-between md:px-8">
        <div className="flex flex-col gap-y-1 text-sm font-semibold">
          {footerLinks.map(({ id, label }) => (
            <a key={id} href={`/${id}`} onClick={handleInternalNavigation} className="footer-link">
              {label}
            </a>
          ))}
        </div>

        <div className="flex flex-col items-start gap-3 md:items-start">
          <SocialButtons links={footerSocialLinks} />
          <p className="text-sm text-slate-600">&copy; 2004-2026 Korea Arts Foundation of America</p>
        </div>
      </div>
    </footer>
  );
}

function SocialButtons({ links }) {
  return (
    <div className="flex items-center gap-3">
      {links.map(({ label, href, icon: Icon }) => (
        <a
          key={label}
          href={href}
          target={href.startsWith('http') ? '_blank' : undefined}
          rel={href.startsWith('http') ? 'noreferrer' : undefined}
          aria-label={label}
          title={label}
          className="icon-button"
        >
          <Icon />
        </a>
      ))}
    </div>
  );
}

function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
      <path d="M14.1 8.7V6.9c0-.8.5-1 1-1h1.4V3.4c-.7-.1-1.5-.2-2.2-.2-2.2 0-3.8 1.4-3.8 3.9v1.6H8v2.8h2.5v9.3h3.1v-9.3h2.5l.4-2.8h-2.4Z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
      <path d="M7.8 2.8h8.4a5 5 0 0 1 5 5v8.4a5 5 0 0 1-5 5H7.8a5 5 0 0 1-5-5V7.8a5 5 0 0 1 5-5Zm0 2.8a2.2 2.2 0 0 0-2.2 2.2v8.4a2.2 2.2 0 0 0 2.2 2.2h8.4a2.2 2.2 0 0 0 2.2-2.2V7.8a2.2 2.2 0 0 0-2.2-2.2H7.8Zm4.2 2.5a3.9 3.9 0 1 1 0 7.8 3.9 3.9 0 0 1 0-7.8Zm0 2.7a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Zm4.2-3.1a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" />
    </svg>
  );
}

function EmailIcon() {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
      <path d="M4.5 5h15A2.5 2.5 0 0 1 22 7.5v9a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 16.5v-9A2.5 2.5 0 0 1 4.5 5Zm.2 3 7.3 5.1L19.3 8H4.7Zm14.8 8.4V10.8l-7.5 5.3-7.5-5.3v5.6h15Z" />
    </svg>
  );
}

function getPageFromRoute() {
  const archivePage = archivePages.find(({ path }) => path === window.location.pathname);
  if (archivePage) {
    return archivePage.path;
  }

  const pagePath = window.location.pathname === '/' ? 'home' : window.location.pathname.replace(/^\//, '');
  if (pages.some(({ id }) => id === pagePath)) {
    return pagePath;
  }

  return 'home';
}

export default App;
